<template>
  <div class="mt-10">
    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Welcome message
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            Welcome message makes the chat button more noticeable to new
            visitors of your store. We only show once a day.
          </p>
          <div>
            <CalloutCardPreview :config="config" />
          </div>
        </div>
        <div class="md:col-span-2">
          <fieldset class="mt-6">
            <legend class="text-base leading-6 font-medium text-gray-900">
              Enable Welcome message
            </legend>

            <div class="mt-4 flex flex-wrap">
              <VSwitch v-model="config.welcomeMessage.isEnabled" />
            </div>
          </fieldset>
          <div class="mt-6">
            <div class="">
              <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 sm:col-span-12 lg:col-span-12 relative">
                  <label
                    for="city"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Message text</label
                  >
                  <input
                    class="mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="config.welcomeMessage.text"
                  />
                  <p
                    v-if="hasMoreCharacters"
                    class="mt-2 text-sm text-red-600"
                    id="email-error"
                  >
                    Button Label should be less than 40 characters
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-6">
            <div class="">
              <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 sm:col-span-12 lg:col-span-12 relative">
                  <label
                    for="city"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Message delay (in seconds)</label
                  >

                  <input
                    class="mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    type="number"
                    v-model="config.welcomeMessage.delay"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  class="Polaris-Button Polaris-Button--primary"
                  type="submit"
                  @click="save"
                >
                  <span class="Polaris-Button__Content">
                    <span class="Polaris-Button__Text">Save</span>
                  </span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSwitch from "../../components/Common/VSwitch";
import CalloutCardPreview from "./CalloutCardPreview";

export default {
  components: {
    VSwitch,
    CalloutCardPreview
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    hasMoreCharacters() {
      const label = this.config.welcomeMessage.text;
      return label.length > 40;
    }
  },
  methods: {
    save() {
      if (this.hasMoreCharacters) {
        alert("welcome message should be less than 40 characters");
        return;
      }
      this.$emit("save");
    }
  }
};
</script>

<style lang="scss" scoped></style>
